// extracted by mini-css-extract-plugin
export var contactButton = "styles-module--contactButton--e3d58";
export var getStartedBox = "styles-module--getStartedBox--6247b";
export var inputWithButton = "styles-module--inputWithButton--af465";
export var textBottom = "styles-module--textBottom--5b729";